async function reloadBasket(show = false){
  res = await fetch(window.Shopify.routes.root + "?section_id=basket")
  .then(response => {
    return response.text();
  });

  document.getElementById('basket-outer').innerHTML = res;
  document.querySelector('.site-header__basket-count').innerHTML = document.querySelector('.basket').dataset.qty;
  if(show){
    document.getElementById('basket-outer').classList.remove('hide');
  }

  el = document.querySelector('.basket__item--to-be-removed');
  if(el){
    await updateBasketQuantity(el.dataset.key, 0, show);
    reloadBasket();
  }
}

async function addToBasket(variant, quantity, properties = {}){
  if(document.getElementById('add-to-basket-res')){
    document.getElementById('add-to-basket-res').classList.add('hide');
    document.getElementById('add-to-basket-res').innerHTML = '';
  }
  
  formData = {
    'items': [{
      'id': variant,
      'quantity': quantity,
      'properties': properties
    }]
  };
  return await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  }).then(json => {
    if(typeof json.status === 'undefined'){
      return true;
    }
    if(document.getElementById('add-to-basket-res')){
      document.getElementById('add-to-basket-res').innerHTML = json.message;
      document.getElementById('add-to-basket-res').classList.remove('hide');
    }
    
    return false;
  })
  .catch((error) => {
    console.error('Error:', error);
    return false;
  });
}

async function updateBasketQuantity(key, quantity){
  let updates = {
    [key]: quantity
  };
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({updates})
  })
  
  .then(response => {
    return response.json();
  })
  .then(json => {
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
}


document.addEventListener('change', async function(ev){
  if(ev.target.className == 'basket__item-quantity-input'){
    await updateBasketQuantity(ev.target.parentNode.dataset.key, ev.target.value);
    reloadBasket();
  }
  if(ev.target.id == 'free-gift-choice'){
    el = document.querySelector('.basket-free-gift');
    if(el){
     await updateBasketQuantity(el.parentNode.parentNode.dataset.key, 0);
    }
    await addToBasket(ev.target.value, 1, {'_free_gift': 1})
    reloadBasket();
  }
});



document.addEventListener('click', async function(ev){
  if(ev.target.id == 'basket-gift-remove'){
    ev.preventDefault();
    updateBasketQuantity(ev.target.dataset.key, 0);
  }
  
  if(ev.target.id == 'basket-close'){
    document.getElementById('basket-outer').classList.add('hide');
  }
  if(!document.getElementById('basket-outer').contains(ev.target) && !document.querySelector('.site-header__basket').contains(ev.target)){
    document.getElementById('basket-outer').classList.add('hide');
  }
  if(ev.target.className == 'basket__item-remove'){
    await updateBasketQuantity(ev.target.parentNode.dataset.key, 0);
    reloadBasket();
  }
  if(ev.target.className == 'basket__item-decrease'){
    qty = parseInt(ev.target.parentNode.querySelector('.basket__item-quantity-input').value);
    if(qty < 2){
      return;
    }
    qty = qty - 1;
    await updateBasketQuantity(ev.target.parentNode.dataset.key, qty);
    reloadBasket();
  }
  if(ev.target.className == 'basket__item-increase'){
    qty = parseInt(ev.target.parentNode.querySelector('.basket__item-quantity-input').value);
    qty = qty + 1;
    await updateBasketQuantity(ev.target.parentNode.dataset.key, qty);
    reloadBasket();
  }
});
